<script>
    import Item from "../navigation/Item.svelte";
    import { createEventDispatcher } from "svelte";
        
    const menu = [
        {name:"Startseite", url:"/"},
        {name:"Personen", url:"/personen"},
        {name:"Orte", url:"/orte"},
        {name:"Über uns", url:"/about"},
        {name:"Impressum", url:"/impressum"},
        {name:"Datenschutz", url:"/datenschutz"},
    ];
    
    const dispatch = createEventDispatcher();

    function closeMenu() {
        dispatch('closeMenu');
        dispatch('closeScanner');
    }
</script>

{#each menu as item}
    <Item {...item} on:closeMenu={closeMenu}/>
{/each}